/** プリフェッチ用。一覧本体は @/features/operation-packages/hooks の ownerProduct キー */
export const operationPackageQueryKeys = {
  all: (id: string) => ['attendance-core/operation-packages', id] as const,
  list: () => ['attendance-core/operation-packages', 'list'] as const,
  countInProgress: (id: string) => [...operationPackageQueryKeys.all(id), 'count-in-progress'] as const,
  patterns: (id: string) => [...operationPackageQueryKeys.all(id), 'patterns'] as const,
  patternCountInProgress: (id: string, patternId: string) => [...operationPackageQueryKeys.all(id), patternId, 'count-in-progress'] as const,
  instances: (patternId: string, page: number, pageSize: number, targetId: string) => [...operationPackageQueryKeys.all(patternId), 'instances', page, pageSize, targetId] as const
} as const;